import { stripCardPromotionsFromPageBlocks } from '~/utils/stripPromoDetails'

export const usePageData = () => {

  const transform = (response) => {
    const { sanitize } = useUtils();
    const data = response?.data || {};
    const attributes = data?.attributes || {};
    return {
      id: data?.id ?? null,
      title: sanitize(attributes.title),
      slug: sanitize(attributes.slug),
      heroHeader: sanitize(attributes.heroHeader),
      displayHeroHeader: sanitize(attributes.displayHeroHeader),
      blocks: sanitize(stripCardPromotionsFromPageBlocks((attributes.blocks || []).map((element) => {
        const result = {
          ...element,
          component: element.__component,
        }
        delete result.__component;
        return result;
      }))),
      brochureRibbon: sanitize(attributes.brochureRibbon),
      brochureRibbonTags: sanitize(attributes.tagsArray),
      jumpToTop: sanitize(attributes.jumpToTop),
      showChatService: sanitize(attributes.showChatService),
      seo: sanitize(attributes.seo),
      parentPage: attributes.parentPage ?? null,
      publishedAt: sanitize(attributes.publishedAt),
      showPromoBanner: attributes.showPromoBanner,
      showTopNavMenu: attributes.showTopNavMenu,
      showFooterMenu: attributes.showFooterMenu,
    }
  }
  
  const getPages = async (deep = true) => {    
    const {find} = useStrapiAsyncData();
    const url = deep ? 'pages?populate=*' : 'pages';
    
    return find(url, transform);
  }

  const getPageById = async (id, deep = true) => {    
    const {findOne} = useStrapiAsyncData();
    const url = 'pages';
    const params = {
      id: id,
      populate: deep ? '?populate=*' : ''
    }
    return findOne(url, params, transform);
  }

  const getPageBySlug = async (slug) => {    
    const {findOneBySlug} = useStrapiAsyncData();
    const url = 'pages';
    const params = {
      slug: slug,
      entity: 'pages'
    }
    return findOneBySlug(url, params, transform);
  }

 
  
  return {
    getPages,
    getPageById,
    getPageBySlug
  }
}
